export const invoiceHeader = [
    "Client","Create","Due","Amount","Sent","Status"
]
export const invoiceBody = [
    {
       img:"05" ,
       client:"Eleanor Pena",
       id:"IHC7456-08086",
       date:"Aug 15,2023",
       due:"Aug 18,2023",
       amount:"$6,05,654",
       sent:"01",
       status:"Done"
    },
    {
        img:"06" ,
        client:"Arlene Mccoy",
        id:"IHC7456-08086",
        date:"Aug 25,2023",
        due:"Aug 30,2023",
        amount:"$5,55,456",
        sent:"04",
        status:"Pending"
     },
     {
        img:"07" ,
        client:"Devon Lane",
        id:"IHC7456-08086",
        date:"May 08,2023",
        due:"May 20,2023",
        amount:"$2,98,852",
        sent:"06",
        status:"Done"
     },
     {
        img:"08" ,
        client:"Ronald Richards",
        id:"IHC7456-08086",
        date:"Feb 14,2023",
        due:"Feb 26,2023",
        amount:"$3,56,158",
        sent:"03",
        status:"In Progress"
     },
]